import React, { FunctionComponent, useState, useEffect } from 'react';

//CSS, STYLES & MEDIA ASSETS
import "./Dashboard.scss"

interface DashboardProps{
}

const Dashboard: FunctionComponent<DashboardProps> = ({
    children
}) => {

    useEffect(() => {
        
    });

    return (
        <div className="dashboard">
            {children}
        </div>
    )
}

export default Dashboard;